<div class="border-top">
  <div class="guts-m-full-1">
    <div class="l_flexbar l_flex-middle">
      <h4 class="h3 ib header-shrink">
        {{ i18n.LearnerHome_LearningBudget }}
      </h4>
    </div>
    <div class="guts-p-t-2 guts-p-b-1 l_flex l_flex-column gap-full-half">
      <a
        class="link par--small font-semibold"
        *ngIf="learnInBalanceUrl"
        [href]="learnInBalanceUrl"
        >{{ i18n.LearnerHome_ViewYourBalance }}</a
      >
      <a class="link par--small font-semibold" (click)="goToMarketplace()">{{
        i18n.LearningSearch_GoToMarketplace
      }}</a>
    </div>
  </div>
</div>
